import * as React              from "react";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

// TODO Not acceptable
import {DownloadMailingList}   from "../../../../../xpresso/src/routes/account/common/mailing-lists-panel/download-mailing-list";
import {formatDate2}           from "../../../format-date";
import {DeleteActionInTable}   from "../../common/design2/data-table-ui/delete-action-in-table/delete-action-in-table";
import {DownloadActionInTable} from "../../common/design2/data-table-ui/download-action-in-table/download-action-in-table";
import {EditActionInTable}     from "../../common/design2/data-table-ui/edit-action-in-table/edit-action-in-table";
import {ConfirmDialog}         from "../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {AddressListTypeIcon}   from "../mailing-icons/address-list-type-icon";

import {CountWarningTooltip} from "./count-warning/count-warning-tooltip";

export const mlContentDataColumns = ({showSource, ml, onEdit, onRemove}) => [
    showSource && {
        render: () => AddressListTypeIcon({
            value: ml.type,
            xdQaName: ml.mailingListName,
        }),
    },
    {
        render: () => ml.mailingListName,
        sortValue: () => ml.mailingListName?.toLowerCase() ?? "",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": ml.mailingListName,
        },
    },
    {
        render: () => <>
            {CountWarningTooltip({
                count: ml.count,
                direction: 'south-west',
                getTooltip: () => <>
                    <div className="mailingListCount">
                        <p className="listCount"><span className="listCountSpan">{ml.count} </span>recipients will be included in your mail order.</p>
                        {(ml.failedCount > 0 || ml.warningCount > 0) && (<>
                            <div className="warningCount">
                                <p className="failed">
                                    <span className="failedSpan">Failed : {ml.failedCount} </span> 
                                    These recipients have failed validation and will not be included in your order.
                                </p>
                                <p className="warning">
                                    <span className="warningSpan">Warning : {ml.warningCount} </span> 
                                    These recipients are at risk of not being mailable but will be included in your order.
                                </p>
                                <p className="passed">
                                    <span className="passedSpan">Passed : {ml.count - ml.warningCount} </span> 
                                    These recipients have been successfully added to your order.
                                </p>
                            </div>
                            <div>
                                <span className="total">Total : {(+ml.count) + (+ml.failedCount)}</span>
                            </div>
                        </>)}
                    </div>
                </>,
            })}
        </>,
        sortValue: () => !ml.count ? 0 : +ml.count,
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": ml.mailingListName + " Count",
        },
    },
    {
        render: () => formatDate2(new Date(ml.dateCreated)),
        sortValue: () => new Date(ml.dateCreated).getTime(),
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": ml.mailingListName + " Date Created",
        },
    },
    {
        render: () => <>
            {cs(
                consumeContext("company"),
                ["allowAddressListDownload", ({company}, next) => next(company?.prefs?.allowAddressListDownload)],
                ["downloadMailingList", ({}, next) => DownloadMailingList({
                    mailingList: ml,
                    next,
                })],   
                ({allowAddressListDownload, downloadMailingList}) => (
                    allowAddressListDownload &&
                    !isApiTrue(ml.purchaseRequired) && (
                        DownloadActionInTable({
                            onDownload: async () => {                              
                                downloadMailingList()
                            },
                            xdQaName: ml.mailingListName
                        })
                    )
                )
            )}

            {isApiTrue(ml.purchaseRequired) ? (
                <div className="buy" xd-qa-type="label" xd-qa-name={ml.mailingListName + " BUY"}>
                    BUY
                </div>
            ) : (
                EditActionInTable({
                    onClick: () => onEdit(ml),
                    xdQaName: ml.mailingListName,

                    ...ml.locked && {
                        disabled: true,
                        tooltip: "List cannot be edited as it will be updated via CRM when order automatically completes checkout",
                    },
                })
            )}

            {cs(
                ["confirmDialog", ({}, next) => ConfirmDialog({next})],
                ({confirmDialog}) => (
                    DeleteActionInTable({
                        onDelete: async () => {
                            if (await confirmDialog.show({
                                message: `This mailing list will be deleted: ${ml.mailingListName}`,
                            })) {
                                await onRemove();
                            }
                        },
                        xdQaName: ml.mailingListName,
                    })
                )
            )}
        </>,
    },
].filter(v => v);
